export const SLUG_TO_ID: Record<string, number> = {
  'qiaodong-workshop': 1,
  'bpf-china-2025': 2,
  'fazi-tour': 3,
  'an-corporation': 4,
  'summer-fades-away': 5,
  'oys-berlin-2026': 6,
};

export const ID_TO_SLUG: Record<number, string> = Object.fromEntries(
  Object.entries(SLUG_TO_ID).map(([slug, id]) => [id, slug])
);

export function resolveEventParam(param: string | undefined): number | string | undefined {
  if (!param) return undefined;
  if (/^\d+$/.test(param)) return Number(param);
  return SLUG_TO_ID[param] ?? param;
}

export function eventHref(id: number): string {
  return `/events/${ID_TO_SLUG[id] ?? id}`;
}
